import { SocialProofSpec } from '../types';

export enum ProductWithSocialProof {
  VHIS_FLEXI_REGULAR = 'vhis-flexi-regular',
  VHIS_FLEXI_PREMIUM_SEMI_PRIVATE = 'vhis-flexi-premium-semi-private',
  TERM_CI_MAX = 'term-ci-max',
  CANCER_FIGHTER_300 = 'cancer-fighter-300',
}

const VHIS_FLEXI_REGULAR_SOCIAL_PROOF_SPEC: SocialProofSpec[] = [
  {
    min_age: 0,
    max_age: 1,
    comparison_result: 52.9,
  },
  {
    min_age: 2,
    max_age: 19,
    comparison_result: 51.6,
  },
  {
    min_age: 20,
    max_age: 29,
    comparison_result: 57.5,
  },
  {
    min_age: 30,
    max_age: 49,
    comparison_result: 56.1,
  },
  {
    min_age: 50,
    max_age: 80,
    comparison_result: 47.8,
  },
];

const VHIS_FLEXI_PREMIUM_SEMI_PRIVATE_SOCIAL_PROOF_SPEC: SocialProofSpec[] = [
  {
    min_age: 0,
    max_age: 1,
    comparison_result: 76.9,
  },
  {
    min_age: 2,
    max_age: 19,
    comparison_result: 76.7,
  },
  {
    min_age: 20,
    max_age: 29,
    comparison_result: 84.7,
  },
  {
    min_age: 30,
    max_age: 49,
    comparison_result: 81.8,
  },
  {
    min_age: 50,
    max_age: 80,
    comparison_result: 79.8,
  },
];

const TERM_CI_MAX_SOCIAL_PROOF_SPEC: SocialProofSpec[] = [
  {
    min_age: 0,
    max_age: 1,
    comparison_result: 69,
  },
  {
    min_age: 2,
    max_age: 19,
    comparison_result: 74.4,
  },
  {
    min_age: 20,
    max_age: 29,
    comparison_result: 78.2,
  },
  {
    min_age: 30,
    max_age: 49,
    comparison_result: 79.1,
  },
  {
    min_age: 50,
    max_age: 65,
    comparison_result: 72.8,
  },
];

const CANCER_FIGHTER_300_SOCIAL_PROOF_SPEC: SocialProofSpec[] = [
  {
    min_age: 0,
    max_age: 1,
    comparison_result: 67.8,
  },
  {
    min_age: 2,
    max_age: 19,
    comparison_result: 70.8,
  },
  {
    min_age: 20,
    max_age: 29,
    comparison_result: 66.5,
  },
  {
    min_age: 30,
    max_age: 49,
    comparison_result: 59.4,
  },
  {
    min_age: 50,
    max_age: 65,
    comparison_result: 42.7,
  },
];

export const SOCIAL_PROOF_BY_PRODUCT = {
  [ProductWithSocialProof.VHIS_FLEXI_REGULAR]:
    VHIS_FLEXI_REGULAR_SOCIAL_PROOF_SPEC,
  [ProductWithSocialProof.VHIS_FLEXI_PREMIUM_SEMI_PRIVATE]:
    VHIS_FLEXI_PREMIUM_SEMI_PRIVATE_SOCIAL_PROOF_SPEC,
  [ProductWithSocialProof.TERM_CI_MAX]: TERM_CI_MAX_SOCIAL_PROOF_SPEC,
  [ProductWithSocialProof.CANCER_FIGHTER_300]:
    CANCER_FIGHTER_300_SOCIAL_PROOF_SPEC,
};
